export default __webpack_public_path__ + "static/media/Danielle_Penman.35bf521f.jpg";